import {Link} from '@mui/material';
import PropTypes from 'prop-types';
import {Grid, Segment} from 'semantic-ui-react';
import ExpandCollapseToggleButton from './ExpandCollapseToggleButton';
import SelectedComparableColumns from './SelectedComparableColumns';

SelectedComparableColumnsHeader.propTypes = {
  records: PropTypes.number.isRequired,
  comparablesType: PropTypes.string.isRequired,
  expanded: PropTypes.bool,
  onRemoveAll: PropTypes.func.isRequired,
  onExpandCollapseAll: PropTypes.func.isRequired,
};

const noWrap = {whiteSpace: 'nowrap'};
export default function SelectedComparableColumnsHeader({
  records,
  comparablesType,
  expanded,
  onRemoveAll,
  onExpandCollapseAll,
}) {
  const disabled = records === 0 ? ' disabled' : '';
  const removeAllEnd = records > 0 ? 'Remove ' + (records > 0 ? 'All ' : '') + records + (records > 1 ? ' Properties' : ' Property') : 'Remove All';
  const singularComparablesType = comparablesType.endsWith('s') ? comparablesType.slice(0, -1) : comparablesType;
  return (
    <Segment className="selected-comparable-columns-header">
      <SelectedComparableColumns
        column1={
          <Link className={`remove-all${disabled}`}
                onClick={onRemoveAll}
                component="button">
            {removeAllEnd}
          </Link>
        }
        column2={<h4>Featured</h4>}
        column3={<h4>Land</h4>}
        column4={<h4 style={noWrap}>{singularComparablesType} Price</h4>}
        column5={<h4 style={noWrap}>{singularComparablesType} Date</h4>}
        column6={<h4>DOM</h4>}
        column7={
          <Grid columns={1}>
            <Grid.Row>
              <Grid.Column textAlign="right">
                <ExpandCollapseToggleButton onChange={onExpandCollapseAll} disabled={disabled} collapsed={!expanded}/>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        }
      />
    </Segment>
  );
}
